/*=========================================================================================
  File Name: mutations.js
  Description: Vuex Store - mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


const mutations = {

    // ////////////////////////////////////////////
    // SIDEBAR & UI UX
    // ////////////////////////////////////////////

    UPDATE_SIDEBAR_WIDTH(state, width) {
        state.sidebarWidth = width;
    },
    UPDATE_SIDEBAR_ITEMS_MIN(state, val) {
        state.sidebarItemsMin = val;
    },
    TOGGLE_REDUCE_BUTTON(state, val) {
        state.reduceButton = val;
    },
    TOGGLE_CONTENT_OVERLAY(state, val) {
        state.bodyOverlay = val;
    },
    TOGGLE_IS_SIDEBAR_ACTIVE(state, value) {
        state.isSidebarActive = value;
    },
    UPDATE_THEME(state, val) {
        state.theme = val;
    },
    UPDATE_WINDOW_BREAKPOINT(state, val) {
        state.breakpoint = val;
    },
    UPDATE_PRIMARY_COLOR(state, val) {
        state.themePrimaryColor = val;
    },
    UPDATE_USER_ROLE(state, val) {
        state.userRole = val
        localStorage.setItem('userRole', val)
    },
    // UPDATE_STATUS_CHAT(state, value) {
    //     state.AppActiveUser.status = value;
    // },
    UPDATE_WINDOW_WIDTH(state, width) {
      state.windowWidth = width;
    },


    // ////////////////////////////////////////////
    // COMPONENT
    // ////////////////////////////////////////////

    // VxAutoSuggest
    UPDATE_STARRED_PAGE(state, payload) {
        // find item index in search list state
        const index = state.navbarSearchAndPinList.data.findIndex((item) => item.index == payload.index)
        // update the main list
        state.navbarSearchAndPinList.data[index].highlightAction = payload.val;

        // if val is true add it to starred else remove
        if(payload.val) {
            state.starredPages.push(state.navbarSearchAndPinList.data[index])
        }else {
            // find item index from starred pages
            const index = state.starredPages.findIndex((item) => item.index == payload.index)
            // remove item using index
            state.starredPages.splice(index, 1);
        }
    },

    // The Navbar
    ARRANGE_STARRED_PAGES_LIMITED(state, list) {
        const starredPagesMore = state.starredPages.slice(10);
        state.starredPages = list.concat(starredPagesMore);
    },
    ARRANGE_STARRED_PAGES_MORE(state, list) {
        let downToUp = false
        let lastItemInStarredLimited = state.starredPages[10];
        const starredPagesLimited = state.starredPages.slice(0, 10);
        state.starredPages = starredPagesLimited.concat(list);

        state.starredPages.slice(0,10).map((i) => {
            if(list.indexOf(i) > -1) downToUp = true
        })
        if(!downToUp) {
            state.starredPages.splice(10, 0, lastItemInStarredLimited);
        }
    },

    /* 
        custom 
    */
    GET_HOTEIS(state, hoteis) {       
        state.hoteisvg = hoteis;
    },

    GET_TERAPEUTAS(state, terapeutas) {
        state.terapeutasvg = terapeutas;
    },

    GET_SPAS(state, spas) {
        state.spasvg = spas.map( function(value) {
                        value.label = value.name + ' | ' + value.hotel_id.hvg_nome;
                        return value;
                    });
    }, 

    GET_ROOMS(state, rooms) {
        state.roomspavg = rooms;
    },

    GET_TIPOS_EVENTO(state, tiposEvento) {
        state.tiposEventovg = tiposEvento;
    },

    SET_FEEDBACK(state, feedback){
        state.feedback = feedback; 
    },  

    SET_SPAS(state, spa){                               
        if(spa.constructor === Array){
            state.spasvg = spa;
        }else{                                                   
            state.spasvg.push(spa);
        }
    }, 

    SET_TERAPEUTA(state, terapeuta){                    
        state.terapeutasvg.push(terapeuta);
    }, 

    SET_ROOM(state, room){                              
        state.roomspavg.push(room);
    }, 

    SET_LOGIN_USER_DETAILS(state, data){                
        state.userLoginDetailsName = data.name;
        state.userLoginDetailsId = data.id;
    },  

    MODIFY_SELECTED_SPA(state, data){ 
        state.selectedSpa = data;
    },

    REMOVE_SELECTED_SPA(state){
        state.selectedSpa = {};        
    },

    EDIT_SPA(state, data){   
        let indexTemp = state.spasvg.findIndex((item, idx) => item.spa_id == data.spa_id);

        Object.keys(state.spasvg[indexTemp]).forEach(k =>  state.spasvg[indexTemp][k] = data[k]);
    },

    SORT_SPAS(state,key){
        state.spasvg=state.spasvg.sort((a, b) => (a[key] > b[key]) ? 1 : -1)
    },

    SET_LIST_THERAPISTS(state, therapists){                 
        if(therapists.constructor === Array)                
        {
            state.listTerapeutasvg = therapists;
        }else
        {                                                   
            state.listTerapeutasvg.push(therapists);
        }
    },

    EDIT_THERAPIST(state, data){
        let indexTemp = state.listTerapeutasvg.findIndex((item, idx) => item.therapist_id == data.therapist_id);

        Object.keys(state.listTerapeutasvg[indexTemp]).forEach(k =>  state.listTerapeutasvg[indexTemp][k] = data[k]);
    },  

    SET_LIST_SPA_ROOMS(state, rooms){                  
        if(rooms.constructor === Array)                 
        {
            state.listSpaRoomsvg = rooms;
        }else
        {                                                  
            state.listSpaRoomsvg.push(rooms);           
        }
    }, 

    EDIT_SPA_ROOMS(state, data){ 
        let indexTemp = state.listSpaRoomsvg.findIndex((item, idx) => item.room_id == data.room_id);

        Object.keys(state.listSpaRoomsvg[indexTemp]).forEach(k =>  state.listSpaRoomsvg[indexTemp][k] = data[k]);
    }, 

    SET_LIST_EVENTS(state, data){                   
        if(data.constructor === Array)              
        {
            state.listEventsvg = data;
        }else
        {                                                  
            state.listEventsvg.push(data);       
        }
    },

    EDIT_LIST_EVENTS(state, data){
        let indexTemp = state.listEventsvg.findIndex((item, idx) => item.event_id == data.event_id);

        Object.keys(state.listEventsvg[indexTemp]).forEach(k =>  state.listEventsvg[indexTemp][k] = data[k]);
    }, 

    SET_LIST_SPA_SEARCHED_USERS(state, data){      
        if(data.constructor === Array)                 
        {
            state.listSpaSearchedUsers = data;
        }else
        {                                                  
            state.listSpaSearchedUsers.push(data);           
        }
    },  

    EDIT_LIST_SPA_SEARCHED_USERS(state, data){                  
        let indexTemp = state.listSpaSearchedUsers.findIndex((item, idx) => item.cod_pessoa == data.cod_pessoa);
        
        Object.keys(state.listSpaSearchedUsers[indexTemp]).forEach(k =>  state.listSpaSearchedUsers[indexTemp][k] = data[k]);

    }, 

    SET_LIST_THERAPISTS_BY_SPA(state, data){                   
        if(data.constructor === Array)                 
        {
            state.listTherapistsBySpa = data;
        }else
        {                                                  
            state.listTherapistsBySpa.push(data);           
        }
    }, 

    EDIT_LIST_THERAPISTS_BY_SPA(state, data){                   
        state.listTherapistsBySpa = [];

        state.listTherapistsBySpa = data;
    },
}

export default mutations

